import { useDisabledFields as useDisabledFieldsBase } from 'components/modules/Insurance/hooks/useDisabledFields';
import { Insurance } from 'constants/routes';

const { ROUTE_NAMES } = Insurance;

export const useDisabledFields = () => {
  return useDisabledFieldsBase({ page: ROUTE_NAMES.POLICYHOLDER });
};
